import * as yup from 'yup';

import {
	Row,
	RenderConfig,
	TextInput,
	AssetUploadInput,
	ASSET_TYPE,
	NumberInput,
	SelectInput,
	GAME_NAME,
	APP_ARCHS,
	GAME_NAMES
} from 'commons-ui';

export const FORM_FIELD_KEYS = {
	VERSION_NUMBER: 'versionNumber',
	VERSION_NAME: 'versionName',
	APK_LINK_URL: ASSET_TYPE.APK,
	APK_ARCH: 'arch',
	GAME_NAME: 'gameName'
};

export const validationSchema = yup.object().shape({
	versionNumber: yup.number().required('Version number is required'),
	versionName: yup.string().required('Version name is a required field'),
	[ASSET_TYPE.APK]: yup.mixed().test('file', 'Apk file is required', (file) => {
		if (file && file instanceof File && file.name.endsWith('.apk')) {
			return true;
		}
		return false;
	})
});

const gameNameDependencyResolver = (props: any, dependencyValues: string[]) => {
	const selectedGameName: string = dependencyValues[0]?.toLowerCase();
	if (!selectedGameName || selectedGameName === GAME_NAMES.LUDO.toLowerCase()) {
		return { disabled: true };
	}

	return { disabled: false };
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.GAME_NAME]: new RenderConfig()
		.setName('gameName')
		.setLabel('SubApp Game Name')
		.setRenderer(SelectInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true, options: GAME_NAME }),
	[FORM_FIELD_KEYS.VERSION_NUMBER]: new RenderConfig()
		.setName('versionNumber')
		.setLabel('Version Number')
		.setRenderer(NumberInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),
	[FORM_FIELD_KEYS.VERSION_NAME]: new RenderConfig()
		.setName('versionName')
		.setLabel('Version Name')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.APK_ARCH]: new RenderConfig()
		.setName('arch')
		.setLabel('App Architecture')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false,
			default: null,
			options: APP_ARCHS,
			dependencies: ['gameName'],
			dependencyResolver: gameNameDependencyResolver
		}),
	[FORM_FIELD_KEYS.APK_LINK_URL]: new RenderConfig()
		.setName(ASSET_TYPE.APK)
		.setLabel('Apk')
		.setRenderer(AssetUploadInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true, assetType: ASSET_TYPE.APK })
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.GAME_NAME),
	new Row(FORM_FIELD_KEYS.VERSION_NUMBER),
	new Row(FORM_FIELD_KEYS.VERSION_NAME),
	new Row(FORM_FIELD_KEYS.APK_ARCH),
	new Row(FORM_FIELD_KEYS.APK_LINK_URL)
];
